export default __webpack_public_path__ + "static/demo-27fe800f4bb9bf79e47308fde0791aec.png";